import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SessionManager } from '../../session/service/session-manager';
import { HttpClient } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment-timezone';
import { GlobalEventBus } from '../../shared/event/global-bus';
import { TimezoneStorage } from '../../shared/misc/service/timezone-storage';

@Component({
  templateUrl: './timezone-modal.component.html',
  styleUrls: [ './timezone-modal.component.scss' ]
})
export class TimezoneModalComponent implements OnInit {

  form: FormGroup;
  saving: boolean;
  user: any;

  constructor(public modalRef: BsModalRef,
              private formBuilder: FormBuilder,
              private httpClient: HttpClient,
              private toastrService: ToastrService,
              private globalEventBus: GlobalEventBus,
              private sessionManager: SessionManager) {
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      timezone: [ '', Validators.required ]
    });
    this.loadUser();
    this.globalEventBus.bind('user:updated', () => {
      this.loadUser();
    });
  }

  loadUser() {
    this.sessionManager.getIdentity()
      .subscribe((user: any) => {
        this.user = user;
        const timezone = this.user.timezone || moment.tz.guess();
        this.form.patchValue({
          timezone
        });

        TimezoneStorage.store(timezone);
      });
  }

  save() {
    this.saving = true;
    const timezone = this.form.controls.timezone.value;
    this.httpClient.patch('/account/profile', {
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      phone: this.user.phone,
      timezone: timezone ? timezone.name : ''
    }).pipe(
      finalize(() => {
        this.saving = false;
      })
    ).subscribe(() => {
      this.modalRef.hide();
      this.globalEventBus.emit('user:updated');
    }, () => {
      this.toastrService.error('Could not save changes');
    });
  }
}
